import { axiosInstance } from "./axiosInstance";

export const getCourses = async (filter: object) => {
    const params = Object.keys(filter)
        .map(function (key) {
            return key + "=" + filter[key];
        })
        .join("&");
    return await axiosInstance.get(`/api/feature/membership/courses/fetchUser?${params}`);
}

export const getCourse = async (id: string, include: string = "material") => {
    return await axiosInstance.get(`/api/feature/membership/courses/fetchUser?filter[id]=${id}&include=${include}`);
}

export const getSubmaterials = async (filter: { courseId: string; materialId: string }) => {
    return await axiosInstance.get(
        `/api/feature/membership/courses/fetchUser/submaterial?filter[course_id]=${filter.courseId}&filter[material_id]=${filter.materialId}`
    );
}